import { render, staticRenderFns } from "./PillTabs.vue?vue&type=template&id=7cb74bf2&scoped=true&"
import script from "./PillTabs.vue?vue&type=script&lang=js&"
export * from "./PillTabs.vue?vue&type=script&lang=js&"
import style0 from "./PillTabs.vue?vue&type=style&index=0&id=7cb74bf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb74bf2",
  null
  
)

export default component.exports